import { rem } from 'polished';
import styled, { css } from 'styled-components';

const sizes = {
  ul: {
    gap: 20,
  },
  li: {
    padding: 20,
  },
};

export const iconWrapperStyling = css`
  .counsellor-profile {
    > div:first-child {
      opacity: 0;
    }
    svg {
      display: none;
    }
  }

  .icon-wrapper {
    background: ${({ theme }) =>
      theme.colors.book.appointmentCards.icon.background};
    width: ${rem(40)};
    height: ${rem(40)};
    position: absolute;
    top: ${rem(70)};
    left: ${rem(sizes.li.padding)};
    border-radius: ${rem(8)};
  }
`;

export const Section = styled.section`
  display: block;
  margin-bottom: ${rem(48)};

  h2 {
    margin-bottom: ${rem(20)};
    font-size: ${rem(18)};
    font-weight: 600;
  }

  .eap-service {
    ${iconWrapperStyling}
  }

  .therapy-and-coaching .counsellor-profile > div:first-child {
    svg {
      min-width: ${rem(24)};
      min-height: ${rem(24)};
    }
  }

  .appointment-cards {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    gap: ${rem(sizes.ul.gap)};

    > li {
      width: 100%;
      background: ${({ theme }) =>
        theme.colors.book.appointmentCards.background};
      position: relative;
      padding: ${rem(sizes.li.padding)};
      border-radius: ${rem(12)};
      box-sizing: border-box;
      display: flex;
      flex-flow: row wrap; // needed to change children order
      align-content: flex-start;
    }
  }

  .cancel-button {
    min-width: ${rem(70)};
    margin-left: auto;
  }

  .counsellor-profile {
    width: 100%;
  }

  .appointment {
    width: 100%;
    flex-flow: column;
    align-items: start;

    button {
      width: auto;
      padding-left: ${rem(16)};
      padding-right: ${rem(10)};
      border: ${rem(1)} solid currentcolor;

      svg {
        top: ${rem(4)};
        margin-left: ${rem(6)};
        margin-right: 0;
      }
    }
  }

  .globe {
    margin-right: ${rem(4)};
  }

  .alert {
    width: 100%;
    margin-top: ${rem(20)};

    span {
      font-weight: 400;
    }
  }

  @media screen and (min-width: 430px) and (max-width: 575px),
    screen and (min-width: 681px) and (max-width: 980px),
    screen and (min-width: 1075px) {
    .appointment {
      flex-flow: row;
      align-items: center;
    }
  }

  @media screen and (min-width: 981px) {
    .appointment-cards > li {
      width: calc((100% - ${rem(sizes.ul.gap)}) / 2);
    }
  }
`;
